// third-party
import { FormattedMessage } from 'react-intl';

// material-ui
import { Stack, Typography } from '@mui/material';

// project-imports
import PoweredBy from 'components/PoweredBy';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption" color="textSecondary">
      <FormattedMessage id="footer.copyright" />
    </Typography>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <PoweredBy />
      <Typography variant="caption" color="textSecondary">
        {process.env.REACT_APP_VERSION}
      </Typography>
    </Stack>
  </Stack>
);

export default Footer;
